import * as MuiFormControl from '@mui/material/FormControl'
import React from 'react'

export type FormControlProps = MuiFormControl.FormControlProps

export function FormControl({ children, ...props }: FormControlProps) {
  return <MuiFormControl.default {...props}>{children}</MuiFormControl.default>
}
